import { defineComponent as _defineComponent } from 'vue'
import BButton from 'JS/components/BButton.vue';
import Icon from 'JS/components/Icon.vue';
import { computed, ref, watchEffect } from 'vue';
import { getSalesFlyerPageProductListLink } from '../utilities/product-list';
import { SalesFlyerPageResource } from '../types';
import { useIsMobileAppWebView } from '../composables/mobile-app-web-view';


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesFlyerViewPage',
  props: {
    page: null
  },
  emits: ["load", "shop", "enlarge"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'load', originalEvent: Event);
	(e: 'shop');
	(e: 'enlarge');
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	page: SalesFlyerPageResource,
}





const loaded = ref(false);
function handleImageLoad(e: Event) {
	loaded.value = true;
	emit('load', e);
}

const isMobileWebView = useIsMobileAppWebView();

const shopDealsLink = computed(() => {
	if (isMobileWebView.value) {
		return getSalesFlyerPageProductListLink(props.page);
	}

	return undefined;
});

function handleShopClick() {
	if (isMobileWebView.value) {
		return;
	};

	emit('shop');
}

function handleEnlargeClick() {
	emit('enlarge');
}

function handleOverlayClick(e: MouseEvent) {
	// avoid triggering when a child is clicked
	if (e.target !== overlay.value) {
		return;
	}

	if (isMobileWebView.value) {
		window.location.href = getSalesFlyerPageProductListLink(props.page);
	} else {
		handleShopClick();
	}

}

const overlay = ref<HTMLElement>();
const showOverlay = ref(false);

function handleTouchOverlayButtonClick() {
	// wrapping in setTimeout prevents this click event from getting picked up
	// by the click outside listener below
	setTimeout(() => {
		showOverlay.value = true;
	});
}

watchEffect((onCleanup) => {
	if (!showOverlay.value) {
		return;
	}

	const clickOutsideAbortController = new AbortController();

	window.addEventListener(
		'click',
		e => {
			if (overlay.value && !overlay.value.contains(e.target as Node)) {
				showOverlay.value = false;
			}
		},
		{
			signal: clickOutsideAbortController.signal,
		}
	);

	onCleanup(() => clickOutsideAbortController.abort());
});

const enlargeButtonDescriptionId = computed(() => `enlarge-page-${props.page.pageID}-description`);
const shopDealsButtonLabel = computed(() => `Shop page ${props.page.pageNumber} Deals`);

return { __sfc: true,props, emit, loaded, handleImageLoad, isMobileWebView, shopDealsLink, handleShopClick, handleEnlargeClick, handleOverlayClick, overlay, showOverlay, handleTouchOverlayButtonClick, enlargeButtonDescriptionId, shopDealsButtonLabel, BButton, Icon }
}

})